export default function UserIcon(props: Icon) {
  const { height, width } = props;
  return (
    <svg
      aria-hidden="true"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : height ? height : 14}
      height={height ? height : width ? width : 16}
      viewBox="0 0 14 16"
    >
      <path
        fill="currentColor"
        d="M9.8,9.5c-.9,0-1.328.5-2.8.5s-1.9-.5-2.8-.5A4.2,4.2,0,0,0,0,13.7v.8A1.5,1.5,0,0,0,1.5,16h11A1.5,1.5,0,0,0,14,14.5v-.8A4.2,4.2,0,0,0,9.8,9.5Zm2.7,5H1.5v-.8A2.7,2.7,0,0,1,4.2,11a12.235,12.235,0,0,0,2.8.5A12.118,12.118,0,0,0,9.8,11a2.7,2.7,0,0,1,2.7,2.7ZM7,9A4.5,4.5,0,1,0,2.5,4.5,4.5,4.5,0,0,0,7,9ZM7,1.5a3,3,0,1,1-3,3A3,3,0,0,1,7,1.5Z"
      />
    </svg>
  );
}
